import { computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";

const store = useStore();
const sessionStatus = computed(() => store.getters.getSessionStauts);

axios.defaults.withCredentials = true;

let setSessionStatusFalse: Function;

let onLoading: Function;
let offLoading: Function;
export const setAxiosSessionFunction = (sessionFunction: Function) => {
  setSessionStatusFalse = sessionFunction;
};
export const setLoadingOn = (funtion: Function) => {
  onLoading = funtion;
};
export const setLoadingOff = (funtion: Function) => {
  offLoading = funtion;
};
export const postApi = axios.create({
  baseURL: "/joyworks_as_api",
  timeout: 600000,
});

postApi.interceptors.request.use(
  function (config: any) {
    // onLoading();
    return config;
  },
  function (error: any) {
    // setTimeout(() => {
    //   offLoading();
    // }, 300);
    return Promise.reject(error);
  }
);

postApi.interceptors.response.use(
  function (response: any) {
    // setTimeout(() => {
    //   offLoading();
    // }, 300);
    return response;
  },

  function (error: any) {
    // setTimeout(() => {
    //   offLoading();
    // }, 300);
    if (error.response.status == 403) {
      if (!error.response.request.responseURL.includes("auth/login")) {
        if (!error.response.request.responseURL.includes("auth/checkSession")) {
          console.log("403");
          // setSessionStatusFalse();
        }
      }
    }
    console.log(error);
    return Promise.reject(error);
  }
);

// export function login() {
//   return axios.post(
//     "/fujitecService/getMenuList",
//     {
//       rol_cd: "1",
//     },
//     {
//       withCredentials: true,
//     }
//   );
